import { render } from "./AposToggle.vue?vue&type=template&id=1496659c&scoped=true"
import script from "./AposToggle.vue?vue&type=script&lang=js"
export * from "./AposToggle.vue?vue&type=script&lang=js"

import "./AposToggle.vue?vue&type=style&index=0&id=1496659c&scoped=true&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1496659c"],['__file',"ui/ui/apos/components/AposToggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1496659c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1496659c', __exports__)) {
    api.reload('1496659c', __exports__)
  }
  
  module.hot.accept("./AposToggle.vue?vue&type=template&id=1496659c&scoped=true", () => {
    api.rerender('1496659c', render)
  })

}


export default __exports__